import {
  Box,
  Button,
  ButtonAppearance,
  Checkbox,
  globalTheme,
  Icon,
  SideSheet,
  SideSheetBody,
  SideSheetFooter,
  SideSheetHeader,
  SideSheetSize,
  Text,
  ToggleSwitch,
  useModalState,
} from '@bechtel/gds';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { SearchField } from '~/components/search-field';
import { useToolRoomContext } from '~/context/tool-room-context';

interface ActiveRequisitionHeaderProps {
  searchText: string;
  setSearchText: (val: string) => void;
  projectOnlyCatalogs: boolean;
  setProjectOnlyCatalogs: (val: boolean) => void;
}

const OptionItem = ({ item }: any) => {
  return (
    <Box>
      <Text color="grey.500" size="400">
        {item}
      </Text>
    </Box>
  );
};

export const ActiveRequisitionHeader: FC<ActiveRequisitionHeaderProps> = ({
  searchText,
  setSearchText,
  projectOnlyCatalogs,
  setProjectOnlyCatalogs,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { open, close, visible } = useModalState(false);
  const { showExtendedStats, setShowExtendedStats } = useToolRoomContext();

  return (
    <Box p={{ sm: '500' }} justifyContent={{ sm: 'space-between' }}>
      <Box alignItems={{ sm: 'center' }}>
        <SearchField
          placeholder={t('SEARCH_CATALOG_PLACEHOLDER')}
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          style={{ width: '300px' }}
        />
        <Box ml={{ sm: '500' }}>
          <Checkbox
            checked={projectOnlyCatalogs}
            readOnly
            onChange={() => {
              setProjectOnlyCatalogs(!projectOnlyCatalogs);
            }}
          />
          <Box ml={{ sm: '400' }}>
            <Text color="grey.800" size="400">
              {t('PROJECT_TOOL_CATALOG_ONLY')}
            </Text>
          </Box>
        </Box>
        <Box ml={{ sm: '500' }} alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '300' }}>
            <Text color="grey.800" size="400">
              {t('EXTENDED_STATS')}:
            </Text>
          </Box>
          <ToggleSwitch isToggled={showExtendedStats} onToggle={() => setShowExtendedStats(!showExtendedStats)} />
        </Box>
        <Box px={{ sm: '500' }}>
          <Button appearance={ButtonAppearance.SECONDARY} onClick={() => open()}>
            <Icon icon="sliders" iconStyle="solid" color="grey.600" />
          </Button>
        </Box>
      </Box>

      <Box>
        <Button appearance={ButtonAppearance.SECONDARY} onClick={() => navigate('/requisition/history')}>
          <Icon icon="clock-rotate-left" iconStyle="regular" style={{ marginRight: globalTheme.spacings[300] }} />
          <Text color="grey.700">{t('HISTORY')}</Text>
        </Button>
      </Box>

      <SideSheet visible={visible} style={{ width: '35%' }} size={SideSheetSize.MEDIUM}>
        <SideSheetHeader title={t('FILTERS')} />
        <SideSheetBody></SideSheetBody>
        <SideSheetFooter>
          <Box justifyContent={{ sm: 'flex-end' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              {t('Close')}
            </Button>
            <Button appearance={ButtonAppearance.PRIMARY}>{t('SUBMIT')}</Button>
          </Box>
        </SideSheetFooter>
      </SideSheet>
    </Box>
  );
};
